/* tslint:disable */
/* eslint-disable */
/**
 * DevourPlay OpenAPI (Swagger) Documentation
 * This is the API documentation generated from the swagger comments in the backend. These correspond directly to the client library.
 *
 * The version of the OpenAPI document: N/A
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { LeagueResponse } from './LeagueResponse';
import {
    LeagueResponseFromJSON,
    LeagueResponseFromJSONTyped,
    LeagueResponseToJSON,
    LeagueResponseToJSONTyped,
} from './LeagueResponse';

/**
 * 
 * @export
 * @interface AdminCompleteMatchResponse
 */
export interface AdminCompleteMatchResponse {
    /**
     * 
     * @type {LeagueResponse}
     * @memberof AdminCompleteMatchResponse
     */
    league: LeagueResponse;
    /**
     * 
     * @type {string}
     * @memberof AdminCompleteMatchResponse
     */
    message?: string;
}

/**
 * Check if a given object implements the AdminCompleteMatchResponse interface.
 */
export function instanceOfAdminCompleteMatchResponse(value: object): value is AdminCompleteMatchResponse {
    if (!('league' in value) || value['league'] === undefined) return false;
    return true;
}

export function AdminCompleteMatchResponseFromJSON(json: any): AdminCompleteMatchResponse {
    return AdminCompleteMatchResponseFromJSONTyped(json, false);
}

export function AdminCompleteMatchResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): AdminCompleteMatchResponse {
    if (json == null) {
        return json;
    }
    return {
        
        'league': LeagueResponseFromJSON(json['league']),
        'message': json['message'] == null ? undefined : json['message'],
    };
}

export function AdminCompleteMatchResponseToJSON(json: any): AdminCompleteMatchResponse {
    return AdminCompleteMatchResponseToJSONTyped(json, false);
}

export function AdminCompleteMatchResponseToJSONTyped(value?: AdminCompleteMatchResponse | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'league': LeagueResponseToJSON(value['league']),
        'message': value['message'],
    };
}

